import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MdMoreVert } from 'react-icons/md';

const PanelMenu = ({ direction, children }) => {
  const nodeRef = React.createRef();
  const [isOpen, setIsOpen] = useState(false);

  const handleOutClick = (e) => {
    if (nodeRef.current.contains(e.target)) {
      return;
    }

    setIsOpen(false);
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOutClick, false);
    document.addEventListener('touchend', handleOutClick, false);

    return () => {
      document.removeEventListener('mousedown', handleOutClick, false);
      document.removeEventListener('touchend', handleOutClick, false);
    };
  });

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative w-8" ref={nodeRef}>
      <button type="button" onClick={handleMenuClick}>
        <MdMoreVert size="1.5rem" />
      </button>
      { 
        isOpen &&
          <div className={`absolute py-2 top-0 z-40 shadow-md rounded font-medium bg-white ${direction === 'right' ? 'left-0' : 'right-0'}`}>
            { children }
          </div>
      }
    </div>
  );
};

PanelMenu.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']),
};

PanelMenu.defaultProps = {
  direction: 'left',
};

export default PanelMenu;
